<!-- Filter content: embedded inside the mobile bottom sheet or the desktop dropdown panel,
     both of which already provide their own card/elevation styling. -->
<div class="tw-flex tw-flex-col tw-w-full tw-gap-6">
  <ng-container *ngTemplateOutlet="filterContent"></ng-container>
</div>

<!-- Reusable filter content template -->
<ng-template #filterContent>
  <div
    class="tw-flex tw-rounded-xl tw-p-4"
    [ngClass]="{
      'tw-shadow-elevation-input': allSelected() && !isMobile(),
      'hover:tw-bg-dt-surface-card': !isMobile(),
      'tw-bg-dt-surface-today-tertiary': isMobile() && allSelected(),
    }"
  >
    <app-checkbox
      [id]="title().toLowerCase() + '-all'"
      title="All Bundles"
      [checked]="allSelected()"
      [isMobile]="isMobile()"
      (onChange)="onAllChange($event)"
    ></app-checkbox>
  </div>
  <div class="tw-flex tw-w-full tw-h-[1px] tw-border tw-border-color-border-subtle"></div>
  <app-filter-section
    title="MARKET"
    [options]="markets()"
    [showAll]="false"
    [parentAllSelected]="allSelected()"
    [isMobile]="isMobile()"
    (allChange)="onAllMarketChange($event)"
    (optionChange)="onMarketChange($event)"
  ></app-filter-section>
  <div class="tw-flex tw-w-full tw-h-[1px] tw-border tw-border-color-border-subtle"></div>
  <app-filter-section
    *ngIf="showFeatures"
    title="FEATURES"
    [options]="features()"
    [showAll]="false"
    [parentAllSelected]="allSelected()"
    [isMobile]="isMobile()"
    (allChange)="onAllFeaturesChange($event)"
    (optionChange)="onFeaturesChange($event)"
  ></app-filter-section>
</ng-template>
